import React from 'react';

// Validation method options for concept validation
const validationMethodOptions = [
  'In Vitro Target Validation',
  'In Vitro MoA',
  'In Vivo Models',
  'Ex Vivo Studies',
  'Omics',
  'Bioinformatics & Systems Biology (In Silico)',
  'Clinical Data Mining',
  'Drug Repurposing Screens',
  'Biomarker Studies'
];

// Preclinical PoC options for checkboxes
const preclinicalPoCOptions = [
  'In Vivo Efficacy Studies',
  'Pharmacokinetics (PK) Studies',
  'Pharmacodynamics (PD) Studies',
  'PK/PD Modeling',
  'Early Safety/Toxicity Screens',
  'Biomarker Validation',
  'Drug Formulation Development',
  'Comparative Studies'
];

// Stage-specific form fields configuration
const stageFields = {
  Discovery: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'conceptValidationMethod', label: 'Concept Validation Method', type: 'select', options: validationMethodOptions, required: false, section: 'Assets' },
    { name: 'conceptValidationDetails', label: 'Concept Validation Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indications of Use', type: 'textarea', required: true, section: 'Assets' },
    
    // Plans
    { name: 'targetPreclinicalPoc', label: 'Target Preclinical Proof-of-Concept', type: 'checkbox', options: preclinicalPoCOptions, required: false, section: 'Plans' },
    { name: 'targetPreclinicalPocDetails', label: 'Target Preclinical PoC Details', type: 'textarea', required: false, section: 'Plans' }
  ],
  
  Preclinical: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'conceptValidationMethod', label: 'Concept Validation Method', type: 'select', options: validationMethodOptions, required: false, section: 'Assets' },
    { name: 'conceptValidationDetails', label: 'Concept Validation Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indications of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'preclinicalPocEfficacy', label: 'Preclinical PoC - In Vivo Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocPkpd', label: 'Preclinical PoC - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocSafety', label: 'Preclinical PoC - Safety/Toxicity', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocBiomarker', label: 'Preclinical PoC - Biomarker Validation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocFormulation', label: 'Preclinical PoC - Drug Formulation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocComparative', label: 'Preclinical PoC - Comparative Studies', type: 'textarea', required: false, section: 'Assets' },
    
    // Plans
    { name: 'cmcPlan', label: 'Chemistry, Manufacturing and Controls (CMC) plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalProtocolPlan', label: 'Clinical Protocol plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'investigatorPlan', label: 'Investigator plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'ectdPlan', label: 'eCTD plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'preIndMeetingDate', label: 'Pre-IND Meeting Planned Date', type: 'date', required: false, section: 'Plans' },
    { name: 'indApplicationDate', label: 'IND Application Planned Date', type: 'date', required: false, section: 'Plans' },
    { name: 'indApprovalDate', label: 'IND Approval Planned Date', type: 'date', required: false, section: 'Plans' }
  ],
  
  Phase_I: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'conceptValidationMethod', label: 'Concept Validation Method', type: 'select', options: validationMethodOptions, required: false, section: 'Assets' },
    { name: 'conceptValidationDetails', label: 'Concept Validation Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indications of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'preclinicalPocEfficacy', label: 'Preclinical PoC - In Vivo Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocPkpd', label: 'Preclinical PoC - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocSafety', label: 'Preclinical PoC - Safety/Toxicity', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocBiomarker', label: 'Preclinical PoC - Biomarker Validation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocFormulation', label: 'Preclinical PoC - Drug Formulation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocComparative', label: 'Preclinical PoC - Comparative Studies', type: 'textarea', required: false, section: 'Assets' },
    { name: 'cmc', label: 'CMC', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyDetails', label: 'Phase 1 Study Details and Status', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyOutcomes', label: 'Phase 1 Study Expected Outcomes and Risks', type: 'textarea', required: false, section: 'Assets' },
    
    // Plans
    { name: 'clinicalPocMoa', label: 'Clinical PoC Objectives - MOA', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalPocEfficacy', label: 'Clinical PoC Objectives - Efficacy', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalPocDoseRange', label: 'Clinical PoC Objectives - Dose Range', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalPocPkpd', label: 'Clinical PoC Objectives - PK/PD', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalPocSafety', label: 'Clinical PoC Objectives - Safety', type: 'textarea', required: false, section: 'Plans' },
    { name: 'phase2Plan', label: 'Phase 2 Clinical Study Protocol and Plan', type: 'textarea', required: false, section: 'Plans' }
  ],
  
  Phase_II: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'conceptValidationMethod', label: 'Concept Validation Method', type: 'select', options: validationMethodOptions, required: false, section: 'Assets' },
    { name: 'conceptValidationDetails', label: 'Concept Validation Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indications of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'preclinicalPocEfficacy', label: 'Preclinical PoC - In Vivo Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocPkpd', label: 'Preclinical PoC - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocSafety', label: 'Preclinical PoC - Safety/Toxicity', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocBiomarker', label: 'Preclinical PoC - Biomarker Validation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocFormulation', label: 'Preclinical PoC - Drug Formulation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocComparative', label: 'Preclinical PoC - Comparative Studies', type: 'textarea', required: false, section: 'Assets' },
    { name: 'cmc', label: 'CMC', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyDetails', label: 'Phase 1 Study Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyOutcomes', label: 'Phase 1 Study Outcomes', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase2StudyDetails', label: 'Phase 2 Study Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesMoa', label: 'Clinical PoC Outcomes - MOA', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesEfficacy', label: 'Clinical PoC Outcomes - Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesDoseRange', label: 'Clinical PoC Outcomes - Dose Range', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesPkpd', label: 'Clinical PoC Outcomes - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesSafety', label: 'Clinical PoC Outcomes - Safety', type: 'textarea', required: false, section: 'Assets' },
    
    // Plans
    { name: 'phase3ObjectivesSafety', label: 'Clinical Phase 3 Objectives - Safety', type: 'textarea', required: false, section: 'Plans' },
    { name: 'phase3ObjectivesEfficacy', label: 'Clinical Phase 3 Objectives - Efficacy', type: 'textarea', required: false, section: 'Plans' },
    { name: 'phase3Protocol', label: 'Clinical Phase 3 Clinical Study Protocol', type: 'textarea', required: false, section: 'Plans' },
    { name: 'phase3Management', label: 'Clinical Phase 3 Clinical Study Management Plans', type: 'textarea', required: false, section: 'Plans' },
    { name: 'ndaApplicationDate', label: 'NDA Application Planned Date', type: 'date', required: false, section: 'Plans' },
    { name: 'ndaApprovalDate', label: 'NDA Approval Planned Date', type: 'date', required: false, section: 'Plans' }
  ],
  
  Phase_III: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'conceptValidationMethod', label: 'Concept Validation Method', type: 'select', options: validationMethodOptions, required: false, section: 'Assets' },
    { name: 'conceptValidationDetails', label: 'Concept Validation Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indications of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'preclinicalPocEfficacy', label: 'Preclinical PoC - In Vivo Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocPkpd', label: 'Preclinical PoC - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocSafety', label: 'Preclinical PoC - Safety/Toxicity', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocBiomarker', label: 'Preclinical PoC - Biomarker Validation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocFormulation', label: 'Preclinical PoC - Drug Formulation', type: 'textarea', required: false, section: 'Assets' },
    { name: 'preclinicalPocComparative', label: 'Preclinical PoC - Comparative Studies', type: 'textarea', required: false, section: 'Assets' },
    { name: 'cmc', label: 'CMC', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyDetails', label: 'Phase 1 Study Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase1StudyOutcomes', label: 'Phase 1 Study Outcomes', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase2StudyDetails', label: 'Phase 2 Study Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesMoa', label: 'Clinical PoC Outcomes - MOA', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesEfficacy', label: 'Clinical PoC Outcomes - Efficacy', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesDoseRange', label: 'Clinical PoC Outcomes - Dose Range', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesPkpd', label: 'Clinical PoC Outcomes - PK/PD', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalPocOutcomesSafety', label: 'Clinical PoC Outcomes - Safety', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase3StudyDetails', label: 'Phase 3 Study Details', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase3OutcomesSafety', label: 'Clinical Phase 3 Outcomes - Safety', type: 'textarea', required: false, section: 'Assets' },
    { name: 'phase3OutcomesEfficacy', label: 'Clinical Phase 3 Outcomes - Efficacy', type: 'textarea', required: false, section: 'Assets' },
    
    // Plans
    { name: 'cmcSummary', label: 'CMC Summary Update', type: 'textarea', required: false, section: 'Plans' },
    { name: 'labelingPlan', label: 'Labeling Plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'riskManagementPlan', label: 'Risk Management Plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'ectdPlan', label: 'eCTD Plan', type: 'textarea', required: false, section: 'Plans' },
    { name: 'ndaApplicationDate', label: 'NDA Application Planned Date', type: 'date', required: false, section: 'Plans' },
    { name: 'ndaApprovalDate', label: 'NDA Approval Planned Date', type: 'date', required: false, section: 'Plans' }
  ],
  
  FDA_Review: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indication of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'proposedLabel', label: 'Product Proposed Label', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalEvidence', label: 'Clinical Evidence', type: 'textarea', required: false, section: 'Assets' },
    { name: 'expectedApprovalDate', label: 'Expected Approval Date', type: 'date', required: false, section: 'Assets' },
    
    // Plans
    { name: 'marketAnalysis', label: 'Market Analysis', type: 'textarea', required: false, section: 'Plans' },
    { name: 'marketingStrategy', label: 'Marketing and Sales Strategy', type: 'textarea', required: false, section: 'Plans' },
    { name: 'financialForecast', label: 'Financial Forecast', type: 'textarea', required: false, section: 'Plans' }
  ],
  
  Approved: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Therapeutics'], required: true, section: 'Assets' },
    { name: 'conceptDescription', label: 'Product Concept Description', type: 'textarea', required: true, section: 'Assets' },
    { name: 'indicationsOfUse', label: 'Indication of Use', type: 'textarea', required: true, section: 'Assets' },
    { name: 'proposedLabel', label: 'Product Proposed Label', type: 'textarea', required: false, section: 'Assets' },
    { name: 'clinicalEvidence', label: 'Clinical Evidence', type: 'textarea', required: false, section: 'Assets' },
    { name: 'approvalDate', label: 'Approval Date', type: 'date', required: false, section: 'Assets' },
    
    // Plans
    { name: 'revenueForecast', label: 'Revenue Forecast', type: 'textarea', required: false, section: 'Plans' },
    { name: 'investmentForecast', label: 'Investment and Cost Forecast', type: 'textarea', required: false, section: 'Plans' },
    { name: 'businessStrategy', label: 'Business and Marketing Strategy', type: 'textarea', required: false, section: 'Plans' },
    { name: 'productValuation', label: 'Product Valuation', type: 'textarea', required: false, section: 'Plans' }
  ]
};

const StageInputForm = ({ stage, formData, setFormData }) => {
  const fields = stageFields[stage] || [];
  
  // Group fields by section
  const assetFields = fields.filter(field => field.section === 'Assets');
  const planFields = fields.filter(field => field.section === 'Plans');

  const handleChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const handleCheckboxChange = (fieldName, option, checked) => {
    setFormData(prev => {
      const currentOptions = prev[fieldName] ? [...prev[fieldName]] : [];
      
      if (checked) {
        return {
          ...prev,
          [fieldName]: [...currentOptions, option]
        };
      } else {
        return {
          ...prev,
          [fieldName]: currentOptions.filter(item => item !== option)
        };
      }
    });
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'textarea':
        return (
          <textarea
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            rows="4"
            required={field.required}
          />
        );
      case 'select':
        return (
          <select
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            required={field.required}
          >
            <option value="">Select an option</option>
            {field.options.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        );
      case 'date':
        return (
          <input
            type="date"
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            required={field.required}
          />
        );
      case 'checkbox':
        return (
          <div className="space-y-2">
            {field.options.map(option => (
              <div key={option} className="flex items-center">
                <input
                  type="checkbox"
                  id={`${field.name}-${option}`}
                  checked={formData[field.name]?.includes(option) || false}
                  onChange={(e) => handleCheckboxChange(field.name, option, e.target.checked)}
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                />
                <label htmlFor={`${field.name}-${option}`} className="ml-2 block text-sm text-gray-700">
                  {option}
                </label>
              </div>
            ))}
          </div>
        );
      default:
        return (
          <input
            type={field.type}
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            required={field.required}
          />
        );
    }
  };

  const renderSection = (title, sectionFields) => {
    if (sectionFields.length === 0) return null;
    
    return (
      <div className="mb-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4 pb-2 border-b">{title}</h3>
        <div className="space-y-6">
          {sectionFields.map(field => (
            <div key={field.name} className="mb-4">
              <label htmlFor={field.name} className="block text-gray-700 text-sm font-bold mb-2">
                {field.label}{field.required && <span className="text-red-500">*</span>}
              </label>
              {renderField(field)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      {renderSection('Assets', assetFields)}
      {renderSection('Plans', planFields)}
    </div>
  );
};

export default StageInputForm; 